module.exports = __webpack_public_path__ + "img/payment-unionpay.49acdf6.svg";